module.exports = require("@material-ui/core/Link");